import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ServiceApi } from "../../services/index.service";

const initialState = null;

export const checkIsAdmin = (obj) => {
  return obj?.vchGroupName === "Administrators";
};
const getUserInfo = async (req) => {
  const reqPayload = {
    user_name: req?.preferred_username,
  };
  const serviceapi = new ServiceApi();
  const response = await serviceapi.getUserRoles(reqPayload);
  console.log(response);
  const obj = {
    ...req,
    ...response?.data?.user_roles,
    permissions: response?.data?.permissions,
    tourStatus: response?.data?.tour_guide,
  };
  return obj;
};
export const getUserDetails = createAsyncThunk(
  "settings/getUserDetails",
  async (request, thunkAPI) => {
    try {
      return await getUserInfo(request);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const profileSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    reset: (state) => initialState,
    receiveProfileData: (state, action) => {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserDetails.pending, (state) => {})
      .addCase(getUserDetails.fulfilled, (state, action) => {
        return {...action.payload, tourStatus: null};
      })
      .addCase(getUserDetails.rejected, (state, action) => {});
  },
});

export const { reset, receiveProfileData } = profileSlice.actions;
export default profileSlice.reducer;
